import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';

const Technology: React.FC = () => {
    const { t } = useLang('Technology');
    const { t: s } = useLang('stream_ultra_x');
    const items: any[] = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
    ];

    return (
        <div
            className={`${styles.Technology} GtmModuleData-section`}
            id={'stream-ultra-x-Technology'}
            data-section-id={'stream-ultra-x-Technology'}
            data-section-title={t('title')}
        >
            <div className="info">
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
                <ul className="items">
                    {items?.map((item: any, k: number) => (
                        <li className="item" key={k}>
                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="img">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1754019451391/19.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1754019451391/19.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1754019509245/19_M.jpg"
                    isOpenLazy={true}
                />
                <div className="img-info">
                    <p className="img-title">{s('B_item8_title')}</p>
                    <p className="img-desc">
                        {s.rich('B_item8_desc', {
                            c: (tx: string) => <span className="x">{tx}</span>,
                        })}
                    </p>
                </div>
            </div>

            <div className="position-block" id="stream-ultra-x-Technology-position"></div>
        </div>
    );
};

export default Technology;
